/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp';
import {
    instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppToJSON,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp';

/**
 * @type FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp
 * 
 * @export
 */
export type FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp = FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp;

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp(json)) {
        return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON(json: any): any {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp(value)) {
        return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppToJSON(value as FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp);
    }

    return {};
}

